import api from "./axiosInstance";

export const getBookingsByArtist = async (artistId) => {
  const res = await api.get(`api/v1/bookings/`, {
    params: {
      artist: artistId,
    },
  });
  return res.data;
};
